import api from "@/utils/http";

export * from './type'

/**
 功能：
 time: 2025-51-03 14:51:23
 **/
export function getCustomerConfig() {
    return api.get('/admin/customer/getSetConfig')
}
/**
 功能：
 time: 2025-51-03 13:51:33
 **/
export function getCustomerList(data) {
    return api.post('/admin/customer/getList', data)
}
/**
 功能：
 time: 2025/12/16 11:02
 **/
export function getCustomerSelectList(saler_id) {
    return api.post('/admin/customer/getSearchList', { saler_id: saler_id })
}
/**
 功能：保存
 time: 2025-38-02 16:38:38
 **/
export function saveCustomer(data) {
    return api.post('/admin/customer/eSave', data)
}

/**
 功能：
 time: 2025/12/16 11:13
 **/
export function saveCustomerTransfer(data) {
    return api.post('/admin/customer/transferSave', data)
}

/**
 功能：
 time: 2025-42-02 16:42:10
 **/
export function getCustomerDetail(id) {
    return api.post('/partner/customer/getDetail', { id: id })
}

/**
 功能：
 time: 2025/12/19 13:53
 **/
export function getCustomerContact(id) {
    return api.post('/admin/customer/getContact', { id: id })
}

/**
 功能：
 time: 2025/12/26 13:41
 **/
export function getCustomerInvoice(id) {
    return api.post('/admin/customer/getInvoice', { id: id })
}
/**
 功能：
 time: 2025-48-03 17:48:41
 **/
export function deleteCustomer(id) {
    return api.post('/admin/customer/del', {id: id})
}

/**
 功能：
 time: 2025-48-03 17:48:43
 **/
export function deleteAllCustomer(ids) {
    return api.post('/admin/customer/delAll', {ids: ids})
}